import React from "react";
import GitHubLink from "../components/GitHub";
import "../css/Header.css";

export default class Footer extends React.Component
{
    state = {
        fileName: ""
    };

    render()
    {
        return <div className="Footer">

            <div id="bottom">
                <GitHubLink>Source code on GitHub</GitHubLink>
                {" · "}<a href="https://mozilla.org/MPL/2.0/">MPL 2.0</a>
                {" · "}Questions: <a href="mailto:alexey.parshin at linotex.net">Alexey Parshin</a>
                {" · "}Design: <a href="mailto:perlovka at gmail.com">Michael Perlov</a>
            </div>

        </div>;
    }
}
